import React from 'react';
import Loader from 'src/shared/components/loader/Loader';
import MetricCard from 'src/shared/components/metric-card/MetricCard';
import QuestionButtonHelp from 'src/shared/components/question-button-help/QuestionButtonHelp';
import { useSpeciesMetricsQuery } from 'src/app/dashboard/state/metrics/metricsGraphSlice';
import useProjectFilters from 'src/shared/hooks/useProjectFilters';

const TotalSpeciesMetrics = () => {
    const {
        currentProjectId,
        currentProjectSelectedHabitatAssayType: habitatAssayType,
        currentProjectSelectedDateRange,
    } = useProjectFilters();

    const { currentData, isFetching } = useSpeciesMetricsQuery(
        {
            projectId: currentProjectId || '',
            samples: {
                fromDate: currentProjectSelectedDateRange?.startDate,
                toDate: currentProjectSelectedDateRange?.endDate,
                habitatAssay: habitatAssayType?.key || '',
            },
        },
        {
            skip: !currentProjectId || !habitatAssayType || !currentProjectSelectedDateRange,
        }
    );

    if (!currentData || isFetching) {
        return <Loader />;
    }

    return (
        <MetricCard
            header={'Total Species'}
            content='total species detected'
            helpText={<QuestionButtonHelp type='api' placement='right' slug='total-species' />}
            total={currentData.speciesMetrics.taxonomySummary.length}
        />
    );
};

export default TotalSpeciesMetrics;
